module.exports = __webpack_public_path__ + "static/media/Acheive1.b4e60830.jpg";